import { routes } from '../../utilities/menu/routes'

export const compareRoute = (route: string, pathname: string) => {
  const routeSplitted = route.split('/')
  const pathnameSplitted = pathname.split('/')
  if (routeSplitted.length !== pathnameSplitted.length) {
    return false
  }

  for (let i = 0; i < routeSplitted.length; i++) {
    /**
     * If the route slice is a param, we don't need to compare it
     */
    if (!routeSplitted[i]?.startsWith(':')) {
      if (routeSplitted[i] !== pathnameSplitted[i]) {
        return false
      }
    }
  }

  return true
}

export const getRoutes = (pathname: string) => {
  const splittedPathname = pathname.split('/').slice(1)

  let url = ''
  const path = []
  for (let i = 0; i < splittedPathname.length; i++) {
    url += `/${splittedPathname[i]}`
    const route = routes.find((route) => compareRoute(route.url ?? '', url))

    if (route) {
      path.push(route)
    }
  }

  return path
}
